import { useContext, useEffect, useState } from "react";
import { DataContext } from "../../context/dataContext";
import { useParams, Link } from "react-router-dom";
import Carging from "../../components/Carging";
import Galeria from "../../components/admin/Galeria";

const Work = () => {

    const { id } = useParams();
    const { getDataById, deleteDataById } = useContext(DataContext);
    const [work, setWork] = useState(null);
    const [deleting , setDeleting] = useState(false);

    useEffect(() => {
        getDataById(id).then((data) => {
            setWork(data);
        });
    }, [id]);

    if (work === null) {
        return <Carging />;

    }

    if (work === undefined) {
        return <div>No se encontro..</div>;
    }

    const remove = (id) => {
        setDeleting(true);
        deleteDataById(id)
            .then(() => {
                window.location.href = "/admin/portafolio";
                setDeleting(false);
            });
    }

    return (
        <div className="h-100 d-flex justify-content-center">
            <div className="row flex-grow-1">
                <div className="col-md-6 h-100">
                    <div className="card shadow rounded h-75 w-100">
                        <div className="w-100 h-75">
                            <img src={work.image}
                                alt="Card image cap"
                                className="w-100 h-100"
                                style={{ objectFit: 'cover' }}
                            />
                        </div>
                        <div className="card-body">
                            <Galeria images={work.galeria} />
                        </div>
                    </div>
                </div>

                <div className="col-md-6 h-100">
                    <div className="card shadow rounded h-75">
                        <div className="card-body p-5">
                            <div>
                                <small>Title:</small>
                            </div>
                            <h5 className="card-title">{work.title}</h5>
                            <small className="mt-1">Description:</small>
                            <div className="card-text">
                                {work.description}
                                <br />
                                <div className="mt-2">
                                    <small>Tags:</small>
                                </div>
                                {work.tags.split(",").map((tag, index) => (
                                    <span key={index} className="badge bg-secondary me-2">{tag} </span>
                                ))}

                                <br />
                                <div className="mt-2">
                                    <small>Link:</small>

                                </div>
                                <small className="text-muted">
                                    <span className="text-primary">
                                        {work.Link}
                                    </span>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ps-2 d-flex flex-column justify-content-between h-50">
                <Link to="/admin/portafolio" className="btn bg-white shadow">
                    <i className="bi bi-arrow-left"></i>
                </Link>

                <Link to={`/admin/portafolio/edit/${work.id}`} className="btn bg-white shadow">
                    <i className="bi bi-pencil"></i>
                </Link>

                <button className="btn bg-white shadow" onClick={() =>  remove(work.id)}>
                   { !deleting ?  <i className="bi bi-trash"></i>: <Carging />}
                </button>

                <Link to={`/admin/portafolio/edit/${work.id}`} className="btn bg-white shadow">
                    <i className="bi bi-heart"></i>
                </Link>

                <Link to={`/admin/portafolio/edit/${work.id}`} className="btn bg-white shadow">
                    <i className="bi bi-eye"></i>
                </Link>
            </div>
        </div>
    );

}

export default Work;
